module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "regionalTeamList"
  }, [_c('x-header', {
    staticClass: "zdyheaderBlue"
  }, [_vm._v("区域服务")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('scroller', {
    ref: "scrollerBottom",
    attrs: {
      "lock-x": "",
      "height": "-50",
      "scroll-bottom-offst": 200
    },
    on: {
      "on-scroll-bottom": _vm.onScrollBottom
    }
  }, [_c('ul', _vm._l((_vm.teamList), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('img', {
      staticClass: "sculpture",
      attrs: {
        "src": item.tx
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "dection"
    }, [_c('p', {
      staticStyle: {
        "color": "#000"
      }
    }, [_vm._v(_vm._s(item.title) + " "), _c('a', {
      staticStyle: {
        "color": "#4ba7e8"
      },
      attrs: {
        "href": 'tel:' + item.tel
      }
    }, [_vm._v(_vm._s(item.tel))])]), _vm._v(" "), _c('p', {
      staticClass: "one"
    }, [_vm._v("服务区域:" + _vm._s(item.regional))]), _vm._v(" "), _c('p', {
      staticClass: "two"
    }, [_c('span', [_vm._v("服务内容：")]), _vm._v(_vm._s(item.dection))])]), _vm._v(" "), _c('div', {
      staticClass: "wechatImg"
    }, [_c('img', {
      attrs: {
        "src": item.src
      }
    }), _vm._v(" "), _c('p', [_vm._v("长按加微信")]), _vm._v(" "), _c('x-button', {
      staticClass: "buleBtn",
      attrs: {
        "plain": "",
        "mini": "",
        "type": "primary"
      },
      nativeOn: {
        "click": function($event) {
          _vm.$router.push({
            path: '/regionalTeamDetail',
            query: {
              item: JSON.stringify(item)
            }
          })
        }
      }
    }, [_vm._v("详情")])], 1)])
  })), _vm._v(" "), _c('load-more', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.downLoadingShow),
      expression: "downLoadingShow"
    }],
    attrs: {
      "tip": _vm.downLoadingTxt
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-759102b9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/regionalServiceProject/regionalTeamList.vue
// module id = mzcA
// module chunks = 5